export default "__VITE_ASSET__36ffe148__"